import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Images
import Logo from '../../images/logo.png';
import footerBg from '../../images/background/footer.jpg';
import ptImg1 from '../../images/shap/wave-blue.png';
import ptImg2 from '../../images/shap/circle-dots.png';
import ptImg3 from '../../images/shap/plus-blue.png';
import ptImg4 from '../../images/shap/wave-blue.png';

// Social Images
import facebook from '../../images/social/facebook.png';
import twitter from '../../images/social/twitter.png';
import instagram from '../../images/social/instagram.png';
import linkedin from '../../images/social/linkedin.png';

class aboutSection extends Component{
	
	render(){
		const year = new Date().getFullYear();
		

		return(
			<>
				
				<footer className="footer" style={{backgroundImage: "url("+footerBg+")"}}>
					<div className="footer-top">
						<div className="container">
							<div className="row">
								<div className="col-xl-3 col-lg-3 col-md-6">
									<div className="widget widget_info">
										<div className="footer-logo">
											<Link to="/"><img src={Logo} alt=""/></Link>
										</div>
										<div className="ft-contact">
											<p>Organising healthcare facilities for the future that are patient friendly, as well as energy and environmentally friendly.</p>
											<div className="contact-bx">
												<div className="icon"><i className="fas fa-phone-alt"></i></div>
												<div className="contact-number">
													<span>Contact Us</span>
													<h4 className="number">+91 99251 03356</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-6">
									<div className="widget footer_widget ml-50">
										<h3 className="footer-title">Our Service</h3>
										<ul>
											<li><Link to="/healthcare_quality_and_accreditations"><span>Healthcare Quality & Accreditations</span></Link></li>
											<li><Link to="/medical_tourism_in_india"><span>Medical Tourism In India</span></Link></li>
											<li><Link to="/hospital_planning"><span>Hospital Planning</span></Link></li>
											<li><Link to="/management_consulting"><span>Management Consulting</span></Link></li>
											<li><Link to="/human_resource_planning"><span>Human Resource Planning</span></Link></li>
										</ul>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-6">
									<div className="widget footer_widget">
										<h3 className="footer-title">Our Service</h3>
										<ul>
											<li><Link to="/hospital_marketing"><span>Hospital Marketing</span></Link></li>
											<li><Link to="/corporate_and_tpa_business_tie_ups"><span>Corporate And TPA Business Tie_Ups</span></Link></li>
											<li><Link to="/insurance_services"><span>Insurance Services</span></Link></li>
											<li><Link to="/hospital_licenses"><span>Hospital Licenses</span></Link></li>
											<li><Link to="/biomedical_equipment_planning_and_procurement"><span>Biomedical Equipment Planning And Procurement</span></Link></li>
											
										</ul>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6">
									<div className="widget widget_form">
										<h3 className="footer-title">Subcribe</h3>
										{/* <form className="subscribe-form subscription-form mb-30">
											<div className="ajax-message"></div>
											<div className="input-group">
												<input name="email" required="required" className="form-control" placeholder="Email Address" type="email"/>
											</div>
											<button name="submit" value="Submit" type="submit" className="btn btn-secondary shadow w-100">Subscribe Now</button>	
										</form> */}
										<div className="footer-social-link">
											<ul>
												<li><a target="_blank" rel="noreferrer" href="https://www.facebook.com/"><img src={facebook} alt=""/></a></li>
												<li><a target="_blank" rel="noreferrer" href="https://twitter.com/"><img src={twitter} alt=""/></a></li>
												<li><a target="_blank" rel="noreferrer" href="https://www.instagram.com/"><img src={instagram} alt=""/></a></li>
												<li><a target="_blank" rel="noreferrer" href="https://www.linkedin.com/"><img src={linkedin} alt=""/></a></li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="container">
						<div className="footer-bottom">
							<div className="row">
								<div className="col-12 text-center"> 

								<p className="copyright-text">
      ©️ {year} Ansh Healthcare. All rights reserved. | Managed by{' '}
      <a
        href="https://gurusoftware.in"
        rel="noreferrer"
        target="_blank"
        className="text-secondary"
      >
        Guru Software
      </a>
    </p>								</div>
							</div>
						</div>
					</div>
					<img className="pt-img1 animate-wave" src={ptImg1} alt=""/>
					<img className="pt-img2 animate1" src={ptImg2} alt=""/>
					<img className="pt-img3 animate-rotate" src={ptImg3} alt=""/>
					<img className="pt-img4 animate-wave" src={ptImg4} alt=""/>
				</footer>
			
			</>
		);
	}
}

export default aboutSection;